import './index.less'

const Achievement = () => {
  return (
    <svg
      width="592"
      height="592"
      viewBox="0 0 592 592"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="achievement-bg"
    >
      <circle
        id="circle_1"
        opacity="0.5"
        cx="296"
        cy="296"
        r="183.5"
        stroke="#55A432"
      />
      <circle
        id="circle_2"
        opacity="0.25"
        cx="296"
        cy="296"
        r="239.5"
        stroke="#55A432"
      />
      <circle
        id="circle_3"
        opacity="0.1"
        cx="296"
        cy="296"
        r="295.5"
        stroke="#55A432"
      />
      <g filter="url(#filter0_d_265_3559)">
        <rect
          x="168"
          y="168"
          width="256"
          height="256"
          rx="128"
          fill="#55A432"
          shapeRendering="crispEdges"
          id="circle_cup"
        />
        <path
          d="M296.4 315.6C295.307 315.6 294.4 314.693 294.4 313.6V308C294.4 306.907 295.307 306 296.4 306C297.494 306 298.4 306.907 298.4 308V313.6C298.4 314.693 297.494 315.6 296.4 315.6Z"
          fill="#F3F4F3"
        />
        <path
          d="M311.733 324.667H281.066V320C281.066 315.947 284.346 312.667 288.4 312.667H304.4C308.453 312.667 311.733 315.947 311.733 320V324.667ZM285.066 320.667H307.733V320C307.733 318.16 306.24 316.667 304.4 316.667H288.4C286.56 316.667 285.066 318.16 285.066 320V320.667Z"
          fill="#F3F4F3"
        />
        <path
          d="M312.4 324.667H280.4C279.307 324.667 278.4 323.76 278.4 322.667C278.4 321.573 279.307 320.667 280.4 320.667H312.4C313.494 320.667 314.4 321.573 314.4 322.667C314.4 323.76 313.494 324.667 312.4 324.667Z"
          fill="#F3F4F3"
        />
        <path
          d="M313.147 297.173C312.587 297.173 312.027 296.933 311.627 296.48C311.12 295.893 310.987 295.067 311.307 294.373C312.214 292.293 312.667 290.08 312.667 287.76V279.76C312.667 278.827 312.507 277.92 312.187 276.96C312.16 276.88 312.134 276.773 312.107 276.667C312.027 276.267 312 275.867 312 275.493C312 274.4 312.907 273.493 314 273.493H315.6C320.374 273.493 324.267 277.493 324.267 282.427C324.267 286.507 322.587 290.533 319.68 293.44C319.627 293.493 319.467 293.627 319.44 293.653C317.867 294.96 316.08 296.427 313.68 297.093C313.494 297.147 313.334 297.173 313.147 297.173ZM316.48 277.573C316.614 278.293 316.667 279.04 316.667 279.76V287.76C316.667 288.853 316.587 289.893 316.427 290.96C316.587 290.827 316.72 290.72 316.88 290.587C319.014 288.453 320.267 285.467 320.267 282.427C320.267 280.027 318.64 278 316.48 277.573Z"
          fill="#F3F4F3"
        />
        <path
          d="M278.88 297.067C278.667 297.067 278.48 297.04 278.267 296.96C276.08 296.267 274.027 294.987 272.32 293.28C269.253 289.893 267.733 286.187 267.733 282.267C267.733 277.413 271.547 273.6 276.4 273.6H278.133C278.8 273.6 279.44 273.947 279.813 274.507C280.187 275.067 280.24 275.787 279.973 276.4C279.547 277.36 279.333 278.453 279.333 279.6V287.6C279.333 289.893 279.787 292.133 280.72 294.267C281.04 294.987 280.88 295.813 280.373 296.4C279.973 296.827 279.44 297.067 278.88 297.067ZM275.467 277.68C273.307 278.107 271.733 279.973 271.733 282.267C271.733 285.173 272.907 287.973 275.227 290.533C275.333 290.667 275.467 290.773 275.6 290.88C275.413 289.787 275.333 288.693 275.333 287.6V279.6C275.333 278.96 275.387 278.32 275.467 277.68Z"
          fill="#F3F4F3"
        />
        <path
          d="M296 308.667C284.613 308.667 275.333 299.387 275.333 288V280C275.333 273.013 281.013 267.333 288 267.333H304C310.986 267.333 316.666 273.013 316.666 280V288C316.666 299.387 307.386 308.667 296 308.667ZM288 271.333C283.226 271.333 279.333 275.227 279.333 280V288C279.333 297.2 286.8 304.667 296 304.667C305.2 304.667 312.666 297.2 312.666 288V280C312.666 275.227 308.773 271.333 304 271.333H288Z"
          fill="#F3F4F3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_265_3559"
          x="68"
          y="68"
          width="456"
          height="456"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="50" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.333333 0 0 0 0 0.643137 0 0 0 0 0.196078 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_265_3559"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_265_3559"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Achievement
